import { email, minLength, object, string } from 'valibot';
import { EMAIL_IS_REQUIRED, INVALID_EMAIL, PASSWORD_IS_REQUIRED, PASSWORD_IS_SHORTER_THAN_8_CHARACTERS } from '~/utils/authUtils';

// Create login schema with email and password
export const MagicSchema = object({
  email: string(EMAIL_IS_REQUIRED, [email(INVALID_EMAIL)],),
});

// Create login schema with email and password
export const LoginSchema = object({
  email: string(EMAIL_IS_REQUIRED, [email(INVALID_EMAIL)],),
  password: string(PASSWORD_IS_REQUIRED, [minLength(8, PASSWORD_IS_SHORTER_THAN_8_CHARACTERS)]),
});

export const ResetSchema = object({
  email: string(EMAIL_IS_REQUIRED, [email(INVALID_EMAIL)],),
});
export const NewPasswordSchema = object({
  password: string(PASSWORD_IS_REQUIRED, [minLength(8, PASSWORD_IS_SHORTER_THAN_8_CHARACTERS)]),
});
